import React from 'react';
import SkcLabelPanel from '@/temu-platform/modules/compliance/SkcLabelPanel';
import '@/styles/temu-platform/temu-product-ops.css';

const PHOTO_SYNC_KINDS = ['compliance', 'photoAutoBind'];

/** 合规资质 · 实拍图（侧栏入口，对齐卖家中心商品实拍图列表布局） */
export default function CompliancePhotosPage() {
  return (
    <SkcLabelPanel
      mode="photo"
      active
      defaultReviewFilter="all"
      syncKinds={PHOTO_SYNC_KINDS}
    />
  );
}
